import React, {useState} from 'react';
import {useForm} from "../../shared/utils/forms/useForm";
import {UseFormSubmitModel} from "../../shared/utils/forms/models/UseFormModel";
import {FormElements} from "../../shared/ui/form/FormElements";
import {useAppDispatch} from "../../app/hooks";
import BtnPrimary from "../../shared/ui/button/primary/BtnPrimary";
import {resetRequestCall} from "./loginAPI";
import {resetErrors} from "../../core/errors/errorSlice";


export function RecoveryPswForm({backHandler}: { backHandler: () => void }) {
    const dispatch = useAppDispatch();
    const [message, setMessage] = useState<any>();
    const structureLoginData: any[] = [
        {
            type: 'input',
            name: "email",
            label: "Email",
            dataElement: {
                placeholder: "Inserisci la mail",
                type: 'text',
            },
            col: {xs: "12"},
        },
    ]

    const validationData = {
        email: {
            required: {
                params: {
                    name: "Email",
                },
            },
            email: {
                params: {
                    name: "Email",
                },
            },
        },
    }

    const submitHandler: UseFormSubmitModel = (event, data) => {
        dispatch(resetErrors());
        resetRequestCall({email: data.email.toLowerCase().trim()}).then(res => {
            setMessage("E' stata inviata un'email al tuo indirizzo cliccando sul link potrai richiedere il cambio password")
        })
    };
    const {
        isSubmit,
        errors,
        submitAction,
        changeValue,
        dataForm,
        setData
    } = useForm(submitHandler, validationData);

    return (
        <>
            {message ? <div>{message}</div> : <form className={"w-100"} onSubmit={submitAction}>
                <FormElements
                    structure={structureLoginData}
                    dataForm={dataForm}
                    errors={errors}
                    isSubmit={isSubmit}
                    changeValue={changeValue}
                />
                <a href="#" onClick={backHandler}>Torna al login</a>

                <div className={'btn-row'}>
                    <BtnPrimary className={'w-100'} type={'submit'}>Invia password</BtnPrimary>
                </div>

            </form>}
        </>


    );
}
